<template>
    <select-input
        :value="value"
        :autocomplete="true"
        :placeholder="translate('search')"
        :items="authorizedUsers"
        :filter-function="(item, search) => new RegExp(search, 'i').test(item.FirstName + ' ' + item.LastName)"
        @change="setValue">
            <span v-if="selectedUser">
                <img v-auth-image="selectedUser.ProfilePictureUrl" class="profile-picture"/>
                {{selectedUser.FirstName}} {{selectedUser.LastName}}
            </span>
            <template v-slot:item="{item}">
                <div style="padding:2px 0;">
                    <img v-auth-image="item.ProfilePictureUrl"  class="profile-picture" />
                    {{item.FirstName}} {{item.LastName}}
                </div>
            </template>
    </select-input>
</template>

<script>
import selectInput from './SelectInput.vue'

export default {
    components: {
        selectInput
    },
    model: {
        prop:'value',
        event: 'change'
    },
    props: {
        userList: Array,
        value: String,
        requiredAuth: Array
    },
    computed: {
        selectedUser(){
            return this.userList?.filter(x => x && x.Id == this.value)[0];
        },
        authorizedUsers(){
            return this.requiredAuth ? this.userList?.filter(x => this.requiredAuth.some(y => this.checkAuth(x, y))) : this.userList;
        }
    },
    methods: {
        setValue(val) {
            this.$emit('change', val?.Id)
        }
    }
}
</script>
<style scoped>
    .profile-picture {
        width: 22px;
        height:22px;
        margin-right: 2px;
        border-radius: 4px;
    }
</style>